import { createSlice } from "@reduxjs/toolkit";

import {
  doGetSetting,
  doUpdateSetting,
  doUpdateSettingNoFetching,
  doUpdateBrandSetting,
  doLanguageTranslate,
  doLanguageTranslateNoFetching,
} from "./thunk";

const isActionWithPending = action => {
  return action.type.endsWith("/pending") && !action.type.includes("NoFetching");
};

const isActionWithFulfilled = action => {
  return action.type.endsWith("/fulfilled");
};

const isActionWithFailed = action => {
  return action.type.endsWith("/rejected");
};

const settingSlice = createSlice({
  name: "setting",
  initialState: {
    isFetching: false,
    setting: null,
    translate: null,
  },
  reducers: {},
  extraReducers: builder => {
    builder.addCase(doGetSetting.fulfilled, (state, action) => {
      state.setting = action.payload;
    });
    builder.addCase(doUpdateSetting.fulfilled, (state, action) => {
      state.setting = action.payload;
    });
    builder.addCase(doUpdateSettingNoFetching.fulfilled, (state, action) => {
      state.setting = action.payload;
    });
    builder.addCase(doLanguageTranslate.fulfilled, (state, action) => {
      state.translate = action.payload;
    });
    builder.addCase(doLanguageTranslateNoFetching.fulfilled, (state, action) => {
      state.translate = action.payload;
    });
    builder.addCase(doUpdateBrandSetting.fulfilled, () => {
      window.location.reload(false);
    });
    builder.addMatcher(isActionWithPending, state => {
      state.isFetching = true;
    });
    builder.addMatcher(isActionWithFulfilled, state => {
      state.isFetching = false;
    });
    builder.addMatcher(isActionWithFailed, state => {
      state.isFetching = false;
    });
  },
});

const { reducer: settingReducer } = settingSlice;
export default settingReducer;
